import React from "react";
import { Link } from "react-router-dom";
import { PageHero } from "./About";

const Campus = () => {
  const facilities = [
    {
      title: "Hostels",
      description:
        "Separate boys' and girls' hostels offer airy rooms, hygienic mess facilities and round-the-clock supervision within a safe residential campus.",
      image: "/Campus/hostel.jpg",
      alt: "VDIT campus hostel buildings",
      to: "/campus-life/hostels",
    },
    {
      title: "Cafeteria",
      description:
        "The campus cafeteria serves fresh vegetarian meals, snacks and refreshments in a clean, convenient setting for students and staff.",
      image: "/Campus/Cafeteria.jpg",
      alt: "Cafeteria dining area",
      to: "/campus-life/mess-and-canteen",
    },
    {
      title: "Sports and Gym",
      description:
        "Outdoor grounds and indoor games facilities encourage students to participate in cricket, basketball, volleyball, athletics and recreational activities.",
      image: "/Campus/gym.jpg",
      alt: "Sports ground",
      to: "/campus-life/sports-gym/overview",
    },
    {
      title: "Wi-Fi Campus",
      description:
        "High-speed Wi-Fi connectivity across academic blocks, the library and hostels helps students access digital learning resources throughout the day.",
      image: "/Campus/wifi.jpg",
      alt: "Student using a laptop on campus",
      to: "/campus-life/wifi-campus",
    },
    {
      title: "Computer Center",
      description:
        "Central computing facilities support academic work, laboratory sessions, campus networking and day-to-day digital services for students and staff.",
      image: "/Campus/wifi.jpg",
      alt: "Computer center and network facility",
      to: "/campus-life/computer-center",
    },
    {
      title: "Co-operative Society",
      description:
        "The student consumer store provides stationery, uniform materials, educational aids and daily utility items conveniently within campus.",
      image: "/Coop_images/CoopHero.png",
      alt: "Co-operative society store",
      to: "/campus-life/cooperative-society",
    },
    {
      title: "Welding Research Center",
      description:
        "The Welding Research Center strengthens advanced manufacturing research, skill development and industry-oriented project work.",
      image: "/Infrastructure/MECH/1.jpg",
      alt: "Mechanical engineering welding research facility",
      to: "/campus-life/welding-research-center",
    },
    {
      title: "IIT Bombay Spoken Tutorial",
      description:
        "The IIT Bombay Spoken Tutorial Resource Centre supports self-paced FOSS learning, certification and skill development for students and faculty.",
      image: "/Campus/wifi.jpg",
      alt: "Students using digital learning resources",
      to: "/campus-life/iit-bombay-spoken-tutorial",
    },
  ];

  return (
    <main>
      <PageHero
        title="Our Campus"
        sub="26 acres of green, calm and learning at the foothills of the Western Ghats"
        image="/Campus/hero.jpg"
      />

      <section className="max-w-5xl mx-auto px-6 lg:px-10 py-16">
        <p className="text-[16px] text-[#2a2a2a]/90 leading-relaxed">
          The KLS VDIT campus is set on a 26-acre site in Haliyal, Uttara Kannada
          district. Cradled by a picturesque landscape and forested hills, the
          campus offers an ideal environment for focussed academic work and
          holistic development. Modern academic blocks, well-equipped
          laboratories, hostels and recreational facilities make VDIT a true
          residential learning experience.
        </p>
      </section>

      <section id="facilities" className="bg-surface-alt/60">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16">
          <h2 className="text-3xl md:text-4xl text-brand mb-2 font-semibold" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Facilities</h2>
        </div>
        <div className="pt-6">
          {facilities.map((facility, index) => (
            <section
              key={facility.title}
              className={index % 2 === 0 ? "bg-surface-alt/60 py-14 md:py-16" : "bg-[#f3eadb] py-14 md:py-16"}
            >
              <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
                <div className={index % 2 === 0 ? "" : "md:order-2"}>
                  <img
                    src={facility.image}
                    alt={facility.alt}
                    className="w-full aspect-[4/3] object-cover"
                  />
                </div>
                <div className={index % 2 === 0 ? "" : "md:order-1"}>
                  <h3 className="text-3xl text-brand mb-3 font-semibold" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{facility.title}</h3>
                  <p className="text-[#2a2a2a]/85 leading-relaxed">{facility.description}</p>
                  <Link
                    to={facility.to}
                    className="inline-flex items-center justify-center mt-6 bg-brand text-surface px-6 py-2.5 text-sm font-sans-ui font-semibold tracking-wider hover:bg-brand-dark transition"
                    aria-label={`View ${facility.title}`}
                  >
                    View
                  </Link>
                </div>
              </div>
            </section>
            ))}
        </div>
      </section>

      <section id="library" className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-2 gap-10 items-center">
        <img src="/Campus/library.jpg" alt="Library" className="w-full aspect-[4/3] object-cover" />
        <div>
          <h2 className="text-3xl text-brand mb-3 font-semibold" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Central Library</h2>
          <p className="text-[#2a2a2a]/85 leading-relaxed">
            The library has a rich collection of textbooks, reference works,
            journals and project reports across all engineering disciplines.
            Students enjoy access to e-resources via the VTU consortium, IEEE,
            Springer and DELNET.
          </p>
          <Link
            to="/library"
            className="inline-flex items-center justify-center mt-6 bg-brand text-surface px-6 py-2.5 text-sm font-sans-ui font-semibold tracking-wider hover:bg-brand-dark transition"
            aria-label="View Central Library"
          >
            View
          </Link>
        </div>
      </section>

      <section id="transport" className="bg-surface-alt/60 py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-3xl text-brand mb-3 font-semibold" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Transportation</h2>
            <p className="text-[#2a2a2a]/85 leading-relaxed">
              College buses connect the campus with Haliyal, Dandeli and nearby
              areas, helping day scholars commute comfortably and reliably.
            </p>
            <Link
              to="/campus-life/transportation"
              className="inline-flex items-center justify-center mt-6 bg-brand text-surface px-6 py-2.5 text-sm font-sans-ui font-semibold tracking-wider hover:bg-brand-dark transition"
              aria-label="View Transportation"
            >
              View
            </Link>
          </div>
          <img src="/Campus/transport.jpeg" alt="College transportation" className="w-full aspect-[4/3] object-cover" />
        </div>
      </section>

      <section id="atm" className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-2 gap-10 items-center">
        <img src="/Campus/ATM.jpeg" alt="ATM facility" className="w-full aspect-[4/3] object-cover" />
        <div>
          <h2 className="text-3xl text-brand mb-3 font-semibold" style={{ fontFamily: "'Cormorant Garamond', serif" }}>ATM</h2>
          <p className="text-[#2a2a2a]/85 leading-relaxed">
            On-campus banking access supports students, parents, staff and
            visitors with convenient cash and basic transaction services.
          </p>
          <Link
            to="/campus-life/atm"
            className="inline-flex items-center justify-center mt-6 bg-brand text-surface px-6 py-2.5 text-sm font-sans-ui font-semibold tracking-wider hover:bg-brand-dark transition"
            aria-label="View ATM"
          >
            View
          </Link>
        </div>
      </section>
    </main>
  );
};

export default Campus;
